import { DialogActions } from "@mui/material";
import type { Dispatch, SetStateAction } from "react";
import { SendMailModalMailContentActions } from "./mailContent/actions";
import { SendMailModalRecipientsActions } from "./recipients/actions";
import { SendMailStep } from "./stepper";

interface ISendMailModalActionsProps {
  step: SendMailStep;
  setStep: Dispatch<SetStateAction<SendMailStep>>;
  onSubmit: () => void;
  onClose: () => void;
  loading: boolean;
  submitDisabled: boolean;
}

export const SendMailModalActions = ({
  step,
  setStep,
  onSubmit,
  onClose,
  loading,
  submitDisabled,
}: ISendMailModalActionsProps) => {
  return (
    <DialogActions sx={{ paddingBottom: 3, paddingRight: 3 }}>
      {step === SendMailStep.RECIPIENTS ? (
        <SendMailModalRecipientsActions onClose={onClose} setStep={setStep} />
      ) : (
        <SendMailModalMailContentActions
          setStep={setStep}
          onSubmit={onSubmit}
          onClose={onClose}
          loading={loading}
          submitDisabled={submitDisabled}
        />
      )}
    </DialogActions>
  );
};
